/**
 * Clipboard write with a fallback for browsers (and embedded webviews) where the async Clipboard API
 * is missing or denied. Extracted from site.js so the Family Hub's per-tile copy buttons share one
 * implementation with the dashboard's copy buttons rather than reimplementing the fallback.
 */
export function writeClipboardText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            if (document.execCommand && document.execCommand('copy')) {
                resolve();
            } else {
                reject(new Error('Clipboard copy failed.'));
            }
        } catch (err) {
            reject(err);
        } finally {
            document.body.removeChild(textarea);
        }
    });
}
